import React, { useEffect, useCallback, useState, useRef } from 'react'
import ReactDOM from 'react-dom'

import AppClass from './../../../../../../../../../js/classes/App.js'
import PickPointsClass from './../../../../../../../../../js/classes/PickPoints.js'

import './PickPoints.scss'

const PickPoints = ({ deliveryCode, isDivContainer, onSelectPVZ }) => {
    const mapContainer = useRef(null),
    [ yandexMap, setYandexMap ] = useState(null),
    [ geoLocationAddress, setGeoLocationAddress ] = useState('')

    const htmlTemplateLayout = `<div style="margin-bottom: 10px;">
        <strong>$[properties.balloonContentHeader]</strong>
    </div>
    <div>
        $[properties.balloonContentBody]
    </div>`

    const balloonContentLayout = ymaps.templateLayoutFactory.createClass(
        htmlTemplateLayout, {
            build() {
                this.constructor.superclass.build.call(this)

                const button = this._element.querySelector('.button_select-pick-point')

                if (button) {
                    const point = this.getData().properties._data.pointData

                    if (onSelectPVZ) {
                        button.addEventListener('click', onSelectPVZ.bind(this, point))
                    } else {
                        button.addEventListener('click', selectPickPointHandler.bind(this, point))
                    }
                }
            },

            clear() {
                const button = this._element.querySelector('.button_select-pick-point')

                if (button) {
                    const point = this.getData().properties._data.pointData

                    if (onSelectPVZ) {
                        button.removeEventListener('click', onSelectPVZ)            
                    } else {
                        button.removeEventListener('click', selectPickPointHandler)    
                    }
                }

                balloonContentLayout.superclass.clear.call(this)
            }
        }
    )

    const getPointCoordinates = useCallback((point, type) => {
        return [ point.ADDRESS_LAT, point.ADDRESS_LNG ]
    }),
    getPointContent = useCallback((point, type) => {
        let worktimeContent = ''
        const days = ['Пн.: ', 'Вт.: ', 'Ср.: ', 'Чт.: ', 'Пт.: ', 'Сб.: ', 'Вс.: ']

        if (typeof point.WORK_HOURS === 'string' && type === 'SBL') {
            worktimeContent = point.WORK_HOURS
        } else if (type === 'YANDEX_DELIVERY' && Array.isArray(point.WORK_HOURS)) {
            worktimeContent = point.WORK_HOURS.map((time, index) => {
                const from = [],
                to = []

                if (time?.time_from?.hours < 10) {
                    from.push(`0${ time?.time_from?.hours }`)
                } else {
                    from.push(String(time?.time_from?.hours))
                }

                if (time?.time_from?.minutes < 10) {
                    from.push(`0${ time?.time_from?.minutes }`)
                } else {
                    from.push(String(time?.time_from?.minutes))
                }

                if (time?.time_to?.hours < 10) {
                    to.push(`0${ time?.time_to?.hours }`)
                } else {
                    to.push(String(time?.time_to?.hours))
                }

                if (time?.time_to?.minutes < 10) {
                    to.push(`0${ time?.time_to?.minutes }`)
                } else {
                    to.push(String(time?.time_to?.minutes))
                }

                return `${ days[index] }${ from.join(':') } — ${ to.join(':') }`
            }).join('<br />')
        } else if (typeof point.WORK_HOURS === 'string') {
            worktimeContent = point.WORK_HOURS.split(',').join('<br />')
        } else if (Array.isArray(point.WORK_HOURS)) {
            const worktimeKeys = Object.keys(point.WORK_HOURS)

            worktimeContent = worktimeKeys.map((key, index) => {
                const worktime = point.WORK_HOURS[key]

                return `${ days[index] }${ worktime.C } — ${ worktime.O }`
            }).join('<br />')
        }

        const paymentMethods = []
        if (point.CASH_ALLOWED === 'Y') paymentMethods.push('Расчет наличными')
        if (point.CARD_ALLOWED === 'Y') paymentMethods.push('Расчет картой')
        const paymentMethodsContent = paymentMethods.join('<br />')

        let content = `<strong>Адрес пункта выдачи заказов:</strong>
        <br />${ point.FULL_ADDRESS }`

        if (worktimeContent !== '') {
            content += `<br />
            <br /><strong>Время работы:</strong>
            <br />${ worktimeContent }`
        }

        if (point.ADDITIONAL && point.ADDITIONAL !== '') {
            content += `<br />
            <br /><strong>Описание:</strong>
            <br />${ point.ADDITIONAL }`
        }

        if (paymentMethods.length > 0) {
            content += `<br />
            <br /><strong>Способы оплаты:</strong>
            <br />${ paymentMethodsContent }`
        }

        content += `<br />
        <br /><button class="button button_green button_select-pick-point">Выбрать</button>`

        return {
            pointData: point,
            balloonContentHeader: point.NAME,
            balloonContentBody: content,
            clusterCaption: point.FULL_ADDRESS,
        }
    }),
    handleClose = () => {
        AppClass.runCallback('SELECT_DELIVERY_PVZ', null)
    },
    selectPickPointHandler = useCallback((point) => {
        AppClass.runCallback('SELECT_DELIVERY_PVZ', deliveryCode, point)
    }), 
    getPointProperties = useCallback((point, type) => {        
        const properties = {
            balloonContentLayout : balloonContentLayout,
            iconLayout: 'default#image',
        }

        if (type === 'FIVE_POST') {
            properties.iconImageHref = point.TYPE === 'POSTAMAT' ? '/local/assets/img/5post-postomat.svg' : '/local/assets/img/5post-shop.svg'
            properties.iconImageSize = [30, 45]
            properties.iconImageOffset = [-5, -40]
        } else if (type === 'CDEK') {
            properties.iconImageHref = point.TYPE === 'POSTAMAT' ? '/local/assets/img/cdek-postomat.svg' : '/local/assets/img/cdek-shop.svg'
            properties.iconImageSize = [30, 45]
            properties.iconImageOffset = [-5, -40]
        } else if (type === 'YANDEX_DELIVERY') {
            properties.iconImageHref = '/local/assets/img/yandex-point-icon.svg'
            properties.iconImageSize = [30, 45]
            properties.iconImageOffset = [-5, -40]
        }

        return properties
    })

    const getPlacemark = useCallback((type, point) => {
        return new ymaps.Placemark(
            getPointCoordinates(point, type), 
            getPointContent(point, type), 
            getPointProperties(point, type)
        )
    })

    const createMap = useCallback(() => {
        if (yandexMap) yandexMap.destroy()

        const location = ymaps.geolocation,
        defaultZoom = 14

        const map = new ymaps.Map(mapContainer.current, {
            center: [55.76, 37.64],
            zoom: defaultZoom
        })

        location.get({
            mapStateAutoApply: true
        }).then((result) => {
            const coodinates = result.geoObjects.get(0).geometry.getCoordinates()

            //setGeoLocationAddress(result.geoObjects.get(0).properties.data.description || '')

            map.setCenter(coodinates, defaultZoom)
        }, (err) => {
            console.log('Ошибка: ' + err)
        })

        setYandexMap(map)

        return map
    })
    
    const getCdekPoint = (code, type, pvz) => {
        return {
            NAME : pvz.Name,
            ADDRESS_LAT : +pvz.cY,
            ADDRESS_LNG : +pvz.cX,
            ADDITIONAL : pvz.AddressComment,
            ADDRESS_METRO_STATION : pvz.Metro,
            STATION : pvz.Station,
            PICTURES : pvz.Picture,
            MAX_CELL_DIMENSIONS_HASH : null,
            MAX_CELL_WEIGHT : pvz?.WeightLim?.MAX ?? 0,
            PHONE : pvz.Phone, //FIVE POST - "88005118800" / CDEK — "+79016169706, +73842457805" / SBL — ["+7-800-100-72-69"]
            FULL_ADDRESS : pvz.Address,
            WORK_HOURS : pvz.WorkTime,
            TYPE : type,
            CASH_ALLOWED : pvz.Cash === 'true' ? 'Y' : 'N', //?????
            CARD_ALLOWED : 'N', //?????  pvz.payNal ???
            POINT_GUID : code,
        }
    },
    getCdekPoints = (data) => {
        const PVZs = Object.keys(data.PVZ).reduce((r, key) => {
            const list = data.PVZ[key]

            Object.keys(list).forEach((keyPVZ) => {
                const PVZ = getCdekPoint(keyPVZ, 'TOBACCO', list[keyPVZ])
                
                r[keyPVZ] = PVZ
            })

            return r
        }, {})
        
        /*
        const POSTAMATs = Object.keys(data.POSTAMAT).reduce((r, key) => {
            const list = data.POSTAMAT[key]

            Object.keys(list).forEach((keyPOSTAMAT) => {
                const POSTAMAT = getCdekPoint(keyPOSTAMAT, 'POSTAMAT', list[keyPOSTAMAT])
                
                r[keyPOSTAMAT] = POSTAMAT
            })

            return r
        }, {})
        */

        return { ...PVZs/*, ...POSTAMATs*/ }
    }

    const getSblPoint = (pvz) => {
        let type = null

        if (pvz.type === 'postamat') type = 'POSTAMAT'
        if (pvz.type === 'point') type = 'TOBACCO'

        if (type) {
            return {
                NAME : pvz.address_string,
                ADDRESS_LAT : +pvz.geo_location.lat,
                ADDRESS_LNG : +pvz.geo_location.lon,
                ADDITIONAL : pvz.trip_description,
                ADDRESS_METRO_STATION : '',
                STATION : '', 
                PICTURES : '',
                MAX_CELL_DIMENSIONS_HASH : null,
                MAX_CELL_WEIGHT : pvz?.limits?.width ?? 0,
                PHONE : pvz?.phones.join(' ') || '',
                FULL_ADDRESS : pvz.address_string,
                WORK_HOURS : pvz?.schedule?.regular?.readable ?? '',
                TYPE : type,
                CASH_ALLOWED : pvz?.options?.cash === true ? 'Y' : 'N',
                CARD_ALLOWED : pvz?.options?.card === true ? 'Y' : 'N',
                POINT_GUID : pvz.id,
            }
        }
    },
    getSblPoints = (data) => {
        const PVZs = data.delivery_point_list.reduce((r, point) => {
            const PVZ = getSblPoint(point)
            
            if (PVZ) {
                r.push(PVZ)
            }

            return r
        }, [])

        return PVZs
    },
    getYandexPoint = (pvz) => {
        let type = null

        if (pvz.type === 'terminal') type = 'POSTAMAT'
        if (pvz.type === 'pickup_point') type = 'TOBACCO'

        /*
            pickup_point - пункт выдачи заказов;
            terminal - постомат;
            post_office - почтовое отделение;
            sorting_center - сортировочный центр;
            warehouse — ???
        */

        if (type) {
            return {
                NAME : pvz.name || '',
                ADDRESS_LAT : +pvz.position.latitude,
                ADDRESS_LNG : +pvz.position.longitude,
                ADDITIONAL : pvz?.address?.comment || '',
                ADDRESS_METRO_STATION : '',
                STATION : '', 
                PICTURES : '',
                MAX_CELL_DIMENSIONS_HASH : null,
                MAX_CELL_WEIGHT : null, //pvz?.limits?.width ?? 0,
                PHONE : pvz?.contact?.phone || '',
                FULL_ADDRESS : pvz?.address?.full_address || '',
                WORK_HOURS : pvz?.schedule?.restrictions, //pvz?.schedule?.regular?.readable ?? '',
                TYPE : type,
                CASH_ALLOWED : 'N', //,pvz?.options?.cash === true ? 'Y' : 'N',
                CARD_ALLOWED : 'N', //pvz?.options?.card === true ? 'Y' : 'N',
                POINT_GUID : `${ pvz?.address?.full_address || '' } / ${ pvz.id }`,
            }
        }
    }, 
    getYandexPoints = (data) => {
        const PVZs = data.reduce((r, point) => {
            const PVZ = getYandexPoint(point)
            
            if (PVZ) {
                r.push(PVZ)
            }

            return r
        }, [])

        return PVZs
    }

    const loadPoints = useCallback((map, DELIVERY_CODE) => {
        PickPointsClass.getPoints((err, res) => {
            if (err) {

            } else {
                let data = {}

                switch (DELIVERY_CODE) {
                    case 'CDEK': {
                        data = getCdekPoints(res)
                        
                        break
                    }

                    case 'FIVE_POST': {
                        data = res.pvz.POINTS
                        break
                    }

                    case 'SBL': {
                        data = getSblPoints(res)
                        break
                    }

                    case 'YANDEX_DELIVERY': {
                        data = getYandexPoints(res)
                    }
                }

                const clusterer = new ymaps.Clusterer({
                    preset: 'islands#invertedLightBlueClusterIcons',
                    groupByCoordinates: false,
                    clusterDisableClickZoom: true,
                    clusterHideIconOnBalloonOpen: false,
                    geoObjectHideIconOnBalloonOpen: false,
                    clusterBalloonItemContentLayout: balloonContentLayout
                })

                const keys = Object.keys(data),
                geoObjects = []
                
                keys.forEach((key, i) => {
                    const point = data[key]

                    geoObjects.push(getPlacemark(DELIVERY_CODE, point))
                })

                clusterer.options.set({
                    gridSize: 80,
                    clusterDisableClickZoom: true
                })

                clusterer.add(geoObjects)

                map.geoObjects.add(clusterer)
            }
        }, DELIVERY_CODE, geoLocationAddress)
    })

    useEffect(() => {
        if (deliveryCode) {
            ymaps.ready(() => {
                const map = createMap()

                loadPoints(map, deliveryCode)
            })
        }
    }, [ deliveryCode ])

    if (isDivContainer) {
        return deliveryCode && <div>
            <div className="happy-pick-points__map" ref={ mapContainer }></div>
        </div>
    } else {
        return deliveryCode && <div className="happy-pick-points">
            <div className="happy-pick-points__content">
                <span className="happy-pick-points__close" onClick={ handleClose } />
                <div className="happy-pick-points__title">Выберите пункт вывоза товара: </div>

                <div className="happy-pick-points__map" ref={ mapContainer }></div>
            </div>

            <div className="happy-pick-points__blackmask" onClick={ handleClose } />
        </div>
    }
}

export default PickPoints